import axios from "axios"
import { BaseUrl, JsonConfig, jwtToken } from "./BaseRepository";
import { ErrorMessage, InfoMessage } from "../Utils/Utils";
import ExcelJS from 'exceljs';
import FileSaver from 'file-saver';

export const callGetGridData = async () => {
    try {
        let getUrl = `${BaseUrl}HealthInsurance/GetInsuranceData`
        const res = await axios.get(getUrl, JsonConfig)
        if (res.data.statusCode === 200) {
            const tempData = JSON.parse(res.data.payload)
            return tempData;
        }
        else {
            InfoMessage("There is no data!!!");
            return null;
        }
    }
    catch {
        ErrorMessage("Data Fetching was Failed");
        return null
    }
}

export const csvDownloadHRGridData = async (props) => {
    const temp = props;
    try {
        if (temp.length > 0) {
            const res = await callGetGridData();
            if (res !== null) {
                const date = new Date();
                var todayDate = parseInt(date.getMonth() + 1) + '/' + parseInt(date.getDate()) + '/' + parseInt(date.getFullYear());
                let sampleList = res;
                let loopedList = [];
                loopedList.length = 0;
                let len = sampleList.length;
                let i;
                loopedList.push(["Division", "Corp W2", "SSN", "File", "Full Name","Frequency", "Status", "Code", "ER Cost", "Effective Date", 
                "EE PreTax", "EE PostTax",  "Payroll Code", "Total Cost", "Per Day", todayDate, "Employee Status", "Pay Cycle", "Plan Admin Name", 
                "Plan Type", "TermDate"])
                for (i = 0; i < len; i++) {
                    loopedList.push([
                        sampleList[i].Division,
                        sampleList[i].Corp_W2,
                        sampleList[i].SSN,
                        sampleList[i].File,
                        sampleList[i].Full_Name,
                        sampleList[i].Freq,
                        sampleList[i].Status,
                        sampleList[i].Code,
                        sampleList[i].ER_Cost,
                        sampleList[i].Effective_Date,
                        sampleList[i].EE_PreTax,
                        sampleList[i].EE_PostTax,
                        sampleList[i].Payroll_Code,
                        sampleList[i].Total_Cost,
                        sampleList[i].Per_Day,
                        sampleList[i].NewEmployeeData,
                        sampleList[i].Employee_Status,
                        sampleList[i].Pay_Cycle,
                        sampleList[i].Plan_Admin_Name,
                        sampleList[i].Plan_Type,
                        sampleList[i].TermDate,                       
                    ]);
                }
                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet('Sheet1');
                for (i = 0; i < len; i++) {
                    worksheet.addRow(loopedList[i]);
                }
                workbook.csv.writeBuffer()
                    .then(buffer => {
                        const blob = new Blob([buffer], { type: 'text/csv;charset=utf-8' });
                        FileSaver.saveAs(blob, 'HealthInsuranceData.csv');
                    });
                return "downloaded";
            }
        }
        else { return null }
    }
    catch {
        ErrorMessage("Unable to download");
        return null;
    }
}

export const prepareCSV = async (props) => {
    try {
        const temp = props;
        if (temp.length > 0) {
            const res = await callGetGridData();
            if (res !== null) {
                let sampleList = res;
                let loopedList = [];
                loopedList.length = 0;
                let len = sampleList.length;
                let i;
                loopedList.push(["Company ID", "Employee ID", "Earning or Deduction Name", "Calculation Type", "Calculation Base", "Include Memo Hours",
                    "Amount / Rate", "Frequency Schedule", "Next Date", "Pay Component Frequency", "Selection 1", "Selection 2", "Every [x] Pay Period", "Limit Amount",
                    "Maximum Amount", "Annual Wage Amount", "Group Term Life Policy Amount", "Agency Name", "Agency Street", "Agency City", "Agency State",
                    "Agency Zip", "Garnishment Type", "Case / Account Number", "Additional Number", "Order Start Date", "Plaintiff Name", "Recipient Name",
                    "Recipient SSN", "Provides Medical Support", "Memo", "PI Percent", "PI Calculation Base", "PI Hours", "PI Fixed Amount", "PI Adjustment Amount",
                    "PI Adjustment Dependents", "Minimum Wage Regulation", ""])
                for (i = 0; i < len; i++) {
                    loopedList.push([
                        sampleList[i].Division,
                        "",
                        sampleList[i].Payroll_Code,
                        "FD",
                        "",
                        "",
                        sampleList[i].NewEmployeeData,
                        "",
                        "",
                        "P",
                    ])
                }
                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet('Sheet1');
                for (i = 0; i < len; i++) {
                    worksheet.addRow(loopedList[i]);
                }
                workbook.csv.writeBuffer()
                    .then(buffer => {
                        const blob = new Blob([buffer], { type: 'text/csv;charset=utf-8' });
                        FileSaver.saveAs(blob, 'HealthInsuranceTemplate.csv');
                    });

                return "downloaded"
            }
        }
        else { return null }

    }
    catch {
        ErrorMessage("Unable to download");
        return null;
    }
}